export const getSx = () => ({
  spineWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
  },
  content: {
    textWrap: 'auto',
    width: '59vw',
    boxSizing: 'border-box',
    textAlign: 'justify',
  },
});
